import type { ChainId, TokenDefinition, } from "@bracket/addressbook";
import { wagmiConfig } from "@config";

import { getChainId as wagmiGetChainId } from 'wagmi/actions';

export const raise = ( message: string ): never => {
	throw new Error(`@bracket/stake-app/contracts - ${message}`);
}

export const getChainId = ( ): ChainId => {
	const chainId = wagmiGetChainId(wagmiConfig);
	return chainId;
}


export const getAmount = ( token: TokenDefinition | "ETH", amount: number ): bigint => {
	if(typeof amount === "bigint") return amount;
	const decimals = token === "ETH" ? 18 : token.decimals;
	const symbol = token === "ETH" ? token : token.symbol;
	if( decimals ) {
		const bignum = amount * Number(`1e${decimals}`);
		const floored = Math.floor(bignum);
		return BigInt(floored);
	}
	throw new Error(`@bracket/contractor::getAmount failed to identify decimal precision for token ${symbol}`);
};


export const isObject = ( value: unknown ): value is Object => {
	return typeof value === "object" && !Array.isArray(value) && value !== null;
}

export const serializeContract = ( contract:any ): any => {
	if(isObject(contract)) {
		if("args" in contract) {
			if(contract.args && Array.isArray(contract.args) && contract.args.length ) {
				contract.args = contract.args.map((v) => {
					if(typeof v === "bigint") return v.toString();
					return v;
				})
			}
		}
		return JSON.parse(JSON.stringify(contract));
	}
}
